/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { size } from 'lodash';
import { GET_HANH_TRINH_DON_HANG } from './constant';
import { GetHanhTrinhDonHangActionDone } from './action';
import { getTrackingOrderApi } from './helpers';

function* takeGetHanhTrinhDonHangSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getTrackingOrderApi,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(GetHanhTrinhDonHangActionDone(data.data));
  } catch (error) {
    yield put(GetHanhTrinhDonHangActionDone([]));
    action.callback?.onFail?.(error);
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function*() {
  yield takeLatest(GET_HANH_TRINH_DON_HANG, takeGetHanhTrinhDonHangSaga);
}

